import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelDropdownComponent } from './hotel-dropdown.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [HotelDropdownComponent],
  exports: [HotelDropdownComponent]
})
export class HotelDropdownModule { }


// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/hotel-dropdown/hotel-dropdown.module.ts